/**
 * SetLayer
 */

import $ from 'jquery';
import PhotoSwipe from '../../../node_modules/photoswipe/dist/photoswipe';
import PhotoSwipeUI_Default from '../../../node_modules/photoswipe/dist/photoswipe-ui-default';
import {
    pswpTempate
} from './Template';

export default class Viewer {
    constructor() {
        const _ = this;

        _.modulePhoto = '[data-module-id="photo"]';

        _.init();
    }

    init() {
        const _ = this;

        $('body').append(pswpTempate());

        _.setPhotoSwipe();
    }

    setPhotoSwipe() {
        const _ = this;

        $('body').on('click', _.modulePhoto, function (evt) {
            evt.preventDefault();

            const $target = $(evt.currentTarget),
                dataIndex = $target.data('photo-index'),
                options = {
                    index: dataIndex,
                    history: false,
                    loop: false,
                    barsSize: { top: 44, bottom: 0 }
                },
                pswpElement = $('.pswp').get(0);

            // 웹툰 타입
            const targetIsWebtoon = $($target.get(0)).data('webtoon') || false;
            const $pswpElement = $(pswpElement);

            if (targetIsWebtoon) {
                const webtoonTitle = $($target.get(0)).data('webtoon-title');
                const webtoonHref = $($target.get(0)).data('webtoon-href');
                const $pswpElementTitle = $pswpElement.find('.pswp__top-bar__title');
                const $pswpElementLink = $pswpElement.find('.pswp__footer-area');

                $pswpElementTitle.text(webtoonTitle);
                $pswpElementLink.attr('href', webtoonHref);
                $pswpElement.addClass('pswp__webtoon');
                options.barsSize.bottom = $('body').hasClass('pc') ? 122 : 138;
            } else {
                $pswpElement.removeClass('pswp__webtoon');
            }

            const gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, _.getPhotoList($target), options);
            gallery.init();
        });
    }

    getPhotoList($target) {
        const _ = this;

        let photoList = [];

        const $photos = $target ? $(_.modulePhoto, $target.parent()) : $(_.modulePhoto);
        $photos.each((index, ele) => {
            const $thumb = $('.thumb', ele),
                src = $thumb.data('origin-src'),
                w = $thumb.data('origin-width'),
                h = $thumb.data('origin-height');

            photoList.push({
                src: src,
                w: w,
                h: h
            });
        });

        return photoList;
    }
}